import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useFormBuilder } from '../../../../contexts/FormBuilderContext'; // <--- 1. ИМПОРТИРУЕМ ХУК
import OptionItem from '../OptionItem/OptionItem';
import { QUESTION_TYPES } from '../../questionTypeConstants';
import { FiPlus } from 'react-icons/fi';
import styles from './ChoiceOptionsEditor.module.css';

const MAX_OPTIONS = 10;

// 2. УБИРАЕМ КОЛБЭКИ ИЗ ПРОПСОВ. Компонент теперь принимает только 'question'.
const ChoiceOptionsEditor = ({ question }) => {
    const intl = useIntl();
    // 3. ПОЛУЧАЕМ ВСЕ НЕОБХОДИМЫЕ ФУНКЦИИ ПРЯМО ИЗ КОНТЕКСТА
    const { addOption, updateOption, deleteOption } = useFormBuilder();

    const canAddOption = (question.options?.length || 0) < MAX_OPTIONS;

    return (
        <div className={styles.optionsContainer}>
            {(question.options || []).map((option) => (
                <OptionItem
                    key={option.id || option.temp_id}
                    questionType={question.type}
                    option={option}
                    // 4. Передаем функции, полученные из контекста, в дочерний компонент
                    onUpdate={(newText) => updateOption(question.id || question.temp_id, option.id || option.temp_id, newText)}
                    onDelete={() => deleteOption(question.id || question.temp_id, option.id || option.temp_id)}
                    showDeleteButton={(question.options?.length || 0) > 1}
                    displayIconType={question.type === QUESTION_TYPES.DROPDOWN ? 'none' : question.type}
                />
            ))}
            {canAddOption && (
                <button
                    onClick={() => addOption(question.id || question.temp_id)}
                    className={styles.addOptionButton}
                >
                    <FiPlus /> <FormattedMessage id="question.addOptionButton" />
                </button>
            )}
        </div>
    );
};

export default ChoiceOptionsEditor;
